import { Component, OnInit, TemplateRef } from '@angular/core';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { serviceWorkflow } from '../models/service';
import { AccountService } from '../services/account/account.service';
import { TableHeaderCheckbox } from 'primeng/table';
import { Account } from '../models/account';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare var $: any;

@Component({
  selector: 'app-workflow-customization',
  templateUrl: './workflow-customization.component.html',
  styleUrls: ['./workflow-customization.component.css']
})
export class WorkflowCustomizationComponent implements OnInit {

  modalRef!: BsModalRef;

  // draggableOptions: SortablejsOptions = {
  //   draggable: '.draggable'
  // };

  serviceWorkFlow: any[] = []; accounts: Account[];
  accountId = 0;
  isAdditionalServiceEnabled: boolean = false;
  additionalServices: any = [];
  additionalServicesByParentService: any = [];

  constructor(public foruscareService: ForuscareService, public accountService: AccountService, private modalService: BsModalService) { }

  workFlows = [
    { serviceId: 1, serviceName: "MEDICAL_INFO", draggable: false, serviceOrder: 0, status: true, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 2, serviceName: "REFRACTION", draggable: true, serviceOrder: 1, status: true, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 3, serviceName: "SPECTACLE", draggable: true, serviceOrder: 2, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 4, serviceName: "FUNDUS", draggable: true, serviceOrder: 3, status: true, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 5, serviceName: "REFERRAL", draggable: false, serviceOrder: 4, status: true, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 6, serviceName: "COLOR_VISION", draggable: true, serviceOrder: 5, status: true, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 7, serviceName: "TELE_CONSULTATION", draggable: true, serviceOrder: 6, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 8, serviceName: "SPECTACLE_MODULE", draggable: true, serviceOrder: 7, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
    { serviceId: 9, serviceName: "DOAAS", draggable: true, serviceOrder: 8, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
  ];

  resetWorkFlowObject() {
    this.workFlows = [
      { serviceId: 1, serviceName: "MEDICAL_INFO", draggable: false, serviceOrder: 0, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 2, serviceName: "REFRACTION", draggable: true, serviceOrder: 1, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 3, serviceName: "SPECTACLE", draggable: true, serviceOrder: 2, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 4, serviceName: "FUNDUS", draggable: true, serviceOrder: 3, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 5, serviceName: "REFERRAL", draggable: false, serviceOrder: 4, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 6, serviceName: "COLOR_VISION", draggable: true, serviceOrder: 5, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 7, serviceName: "TELE_CONSULTATION", draggable: true, serviceOrder: 6, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 8, serviceName: "SPECTACLE_MODULE", draggable: true, serviceOrder: 7, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
      { serviceId: 9, serviceName: "DOAAS", draggable: true, serviceOrder: 8, status: false, isMandatory: false, isAdditionalServiceEnabled: false },
    ];
  }


  getId(index) {
    return "serviceenabled" + index;
  }

  additionalServicesApi() {
    this.additionalServices = [];
    this.accountService.getAdditionalServices().subscribe(response => {
      if (response && response.data) {
        response.data.forEach((item) => {
          let serviceObject = { "serviceName": item.serviceName, "id": item.id, "parentServiceName": item.parentServiceName, "status": false }
          this.additionalServices.push(serviceObject);
        })
      }
    })
  }

  getAdditionalServicesByParentService(parentServiceName: any) {
    return this.additionalServices.filter((x: any) => {
      return x.parentServiceName == parentServiceName;
    });
  }

  showAdditionalServicesPopUp(parentServiceName: any, isSelected: boolean) {
    if (isSelected) {
      this.additionalServicesByParentService = this.getAdditionalServicesByParentService(parentServiceName);
      $("#exampleModalCenter").modal("show");
    }
  }

  closeModal() {
    $("#exampleModalCenter").modal("hide");
  }

  getAdditionalServiceName(serviceName) {
    switch (serviceName) {
      case "EXPERT_REVIEW": return "Refraction approval by Expert";
      case "EXPERT_EDIT_REFRACTION": return "Edit Refraction by Expert";
      case "ENABLE_UNCORRECTED_DVA": return "Enable Uncorrected digital Visual Acuity";
      case "ENABLE_CORRECTED_DVA": return "Enable Corrected digital Visual Acuity";
      case "ENABLE_PINHOLE_DVA": return "Enable Pinhole digital Visual Acuity";
      case "CAN_OPERATOR_EDIT_DURING_AV_CALL": return "Allow Operator to edit fields during AV call";
      case "CAN_OPTOPETRIST_EDIT_DURING_AV_CALL": return "Allow Optometrist/Expert to edit fields during AV call";
      default: 'None';
    }
  }

  getServiceWorkFlowByAccountId() {
    let workflows = JSON.parse(JSON.stringify(this.workFlows));
    let additionalServices = JSON.parse(JSON.stringify(this.additionalServices));
    this.additionalServicesApi();
    this.serviceWorkFlow = [];
    if (this.accountId == null || this.accountId == 0) {
      return;
    }
    this.accountService.getAccountWorkflowByAccountId(this.accountId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.length > 0) {
            response.data.forEach(data => {
              if (data.serviceName == "MEDICAL_INFO" || data.serviceName == "REFERRAL") {
                data.draggable = false;
              }
              else {
                data.draggable = true;
              }
              if (data.serviceName == "REFRACTION" && data.isAdditionalServiceEnabled && data.additionalServices && data.additionalServices.length > 0) {
                // this.additionalServices = [];
                // this.additionalServices = data.additionalServices;
              }
            });
            let serviceWorkFlow = response.data;
            serviceWorkFlow.forEach((item) => {
              if (item.isAdditionalServiceEnabled) {
                item.additionalServices.forEach(element1 => {
                  additionalServices.forEach(element2 => {
                    if ((element1.parentServiceName == element2.parentServiceName) && (element1.serviceName == element2.serviceName)) {
                      element2.status = element1.status;
                    }
                  });
                });
              }
            });

            this.additionalServices = additionalServices;

            let work_flow = [];
            workflows.forEach((workflow, index) => {
              /*let work_flow = this.serviceWorkFlow.find(ob => ob.serviceId == workflow.serviceId);
              if (work_flow == null) {
                this.serviceWorkFlow.push(workflow);
              }*/
              let found = false;
              serviceWorkFlow.forEach(ob => {
                if (ob.serviceId == workflow.serviceId) {
                  found = true;
                  work_flow.push(ob);
                }
              });
              if (!found) {
                work_flow.push(workflow);
              }
            });
            this.serviceWorkFlow = work_flow;
            /*sorting workflow as per service order */
            this.serviceWorkFlow.sort((o1: any, o2: any) => {
              if (o1.serviceOrder < o2.serviceOrder) return -1;
              if (o1.serviceOrder > o2.serviceOrder) return 1;
              if (o1.serviceOrder == o2.serviceOrder) return 0;

            });
          }
          else {
            this.resetWorkFlowObject();
            this.serviceWorkFlow = this.workFlows;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getServiceName(serviceid) {
    let serviceinfo = this.workFlows.find(ob => ob.serviceId == serviceid);
    if (serviceinfo != null) {
      switch (serviceinfo.serviceName) {
        case 'MEDICAL_INFO': return 'Medical Info';
        case 'REFRACTION': return 'Basic Refraction';
        case 'SPECTACLE': return 'Spectacle Essilor';
        case 'SPECTACLE_MODULE': return 'Spectacle Module';
        case 'FUNDUS': return 'Fundus';
        case 'REFERRAL': return 'Referral';
        case 'COLOR_VISION': return 'Color Vision';
        case 'TELE_CONSULTATION': return 'Tele Consultation';
        case 'DOAAS': return 'Tele Optometry';
        default: 'None';
      }
    }
  }

  getServiceId(serviceId) {
    console.log("ServiceId --> ", serviceId);
  }

  saveWorkflowSettings() {

    if (this.serviceWorkFlow != null && this.serviceWorkFlow.length > 0) {
      var workFlowToPost = [];

      this.serviceWorkFlow.forEach((workflow, index) => {
        var itemToPush = new serviceWorkflow();
        itemToPush.id = workflow.id;
        itemToPush.accountId = this.accountId;
        itemToPush.serviceOrder = index;
        itemToPush.status = workflow.status;
        itemToPush.isMandatory = workflow.isMandatory;
        itemToPush.serviceId = workflow.serviceId;
        itemToPush.isAdditionalServiceEnabled = workflow.isAdditionalServiceEnabled;
        if (workflow.isAdditionalServiceEnabled) {
          let temp: any[] = [];
          this.additionalServices.forEach(element => {
            if (element.parentServiceName == workflow.serviceName) {
              temp.push(element);
            }
          });
          itemToPush.additionalServices = temp;
        }
        // itemToPush.isEnabled = workflow.isEnabled;
        workFlowToPost.push(itemToPush);
      })
      if (workFlowToPost[0].id == null) {
        this.accountService.addAccountWorkflow(workFlowToPost)
          .subscribe(response => {
            if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
              if (response.data != null) {
                this.foruscareService.showNotification("Workflow saved successfully.", "success");
                this.getServiceWorkFlowByAccountId();
              }
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
              this.getServiceWorkFlowByAccountId();
            }
          });
      }
      else {
        this.accountService.updateAccountWorkflow(workFlowToPost, this.accountId)
          .subscribe(response => {
            if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
              if (response.data != null) {
                this.foruscareService.showNotification("Workflow updated successfully.", "success");
              }
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
      }
    }
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  ngOnInit() {
    this.getAvailableAccounts();
    this.additionalServicesApi();
  }

}
